export function determineAutoReply(conversation, globalAutoReplySettings) {

  let autoReply = conversation.autoReply;

  if (conversation.autoReply === 'NOT_SET') {
    return 'NO_AI';
  }

  return autoReply;

}